import {
  DEFAULT_BUSINESS_METRIC_POINT_MAPPING,
  PLATFORM_METRIC_POINT_MAPPING,
} from './consts';
import { isWebBridgeSupported } from '@shopee-user/platform';
import { getAppType } from '@shopee-user/platform';
import { getNativeVersion } from '@shopee-user/business-customization-logic';
import type { MdapCustomData } from '../mdap/types';

function createAppTimingUtil() {
  let softNavigationStartTime = 0;

  return {
    recordSoftNavigationChanged: () => {
      softNavigationStartTime = Date.now();
    },
    getAppAliveDuration: () => {
      if (self.performance && !!self.performance.now) {
        return window.performance.now();
      }
      // fallback
      return Date.now() - (self.__APP_START_TIME__ || new Date().getTime());
    },
    getDurationFromSoftNavigationStart: () => {
      return softNavigationStartTime ? Date.now() - softNavigationStartTime : 0;
    },
  };
}

export const appTimingUtil = createAppTimingUtil();

const businessCustomMetricMapping: Record<string, string> = {};

// Allow dev to register some specific business metrics
export function registerBusinessCustomMetric(
  metricPointMapping: Record<string, string>
) {
  Object.entries(metricPointMapping).forEach(([metricName, pointId]) => {
    businessCustomMetricMapping[metricName] = pointId;
  });
}

export const mdapHook = {
  // get metric point id from metric name
  onTransformTrackingPointId: (metricName: string) => {
    return (
      PLATFORM_METRIC_POINT_MAPPING[metricName] ||
      DEFAULT_BUSINESS_METRIC_POINT_MAPPING[metricName] ||
      businessCustomMetricMapping[metricName]
    );
  },
  // add platform details to the metric data
  onBeforeSendCustomData: (data: MdapCustomData): MdapCustomData => {
    const appType = getAppType();
    data.data = data.data || {};
    // platform details
    data.data.web_bridge_supported = isWebBridgeSupported() ? 'true' : 'false';
    data.data.app_type = String(appType === undefined ? '-' : appType);
    data.data.app_version = getNativeVersion() || '-';
    data.data.business_target = __BUSINESS_TARGET__;

    return data;
  },
};
